import clone from 'lodash/clone';
import store from "../../../../../store";

import workspace from "../core/workspace";
import {
  MOVABLE_IMAGE_TYPES,
  SHAPE_PART_ID,
} from "../../../constants";
import sqftShape from "../core/shapes/sqftShape";
import ShapeHelper from "../../../helpers/shapeHelper";
import sqftShapeManager from "./sqftShapeManager";
import sqftSlabManager from "./sqftSlabManager";
import {renderErrorPopup} from "../../../../../api/api-popups";
import MovableImage from "../core/shapes/movableImage";
import {INTERSECTION_MODE} from "../core/shapes/shapeParts/shapeIntersections";

const sqftShapeIntersectionsManager = {
  resetShapesIntersections() {
    const shapes = workspace.getShapes();

    for (const shape of shapes) {
      if (!(shape instanceof sqftShape) && !(shape instanceof MovableImage)) {
        continue;
      }

      shape.shapeIntersections.resetCurrentMode();
    }
  },
  updateShapesIntersections() {
    this.resetShapesIntersections();

    const shapes = workspace.getShapes();

    for (const shape of shapes) {
      if (!(shape instanceof sqftShape) && !(shape instanceof MovableImage)) {
        continue;
      }

      for (const testShape of shapes) {
        if (!(testShape instanceof sqftShape) && !(testShape instanceof MovableImage)) {
          continue;
        }

        if (shape.id === testShape.id) {
          continue;
        }

        if (testShape.isHidden) {
          continue;
        }

        const overlapInfo = ShapeHelper.getTwoShapesOverlapInfo(shape, testShape);

        if (overlapInfo.isOverlapped) {
          shape.shapeIntersections.addOverlappedWithShape(testShape.id);
        }
      }
    }
  },
  logShapeFeatureIds() {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      console.log("shape id", shape.id);
      console.log("shape feature id", shape.featureId);
      console.log("shape shapeIntersections getOverlappedWithShapeIds()", shape.shapeIntersections.getOverlappedWithShapeIds());
    }
  },
  logSnappedShapeGroups() {
    const shapes = workspace.getShapes();
    console.log("------");
    for (const shape of shapes) {
      if (shape instanceof sqftShape) {
        console.log("shape id", shape.id);
        console.log("shape area", shape.getTotalArea());
        console.log("shape getSnappedShapeGroup", shape.shapeAbsolute.getSnappedShapeGroup());
        console.log("shape shapeSlab getSnappedShapeGroup", shape.shapeSlab.shapeAbsolute.getSnappedShapeGroup());
      }
    }
    console.log("------");
  },
  syncSlabFeaturesFromCountertopShape(shapeId) {
    const sourceShape = sqftShapeManager.getShapeById(shapeId);
    if (!sourceShape || !sourceShape.featureId) {
      return;
    }

    const overlappedIds = (sourceShape.shapeIntersections?.getOverlappedWithShapeIds(INTERSECTION_MODE.SLAB) || [])
      .slice()
      .sort((a, b) => a - b); // deterministic order

    for (const overlappedId of overlappedIds) {
      const targetShape = sqftShapeManager.getShapeById(overlappedId);
      if (!targetShape) continue;

      // slab image must inherit feature from the changed countertop
      if (targetShape instanceof MovableImage && targetShape.type === MOVABLE_IMAGE_TYPES.slabImage) {
        targetShape.setFeatureId(clone(sourceShape.featureId));
        continue;
      }

      // slab placeholder must inherit feature from the changed countertop
      if (targetShape instanceof sqftShape && targetShape.partId === SHAPE_PART_ID.slabPlaceHolder) {
        targetShape.setFeatureId(clone(sourceShape.featureId));
        targetShape.setSlabParentPartId(
          sourceShape.slabParentPartId ? sourceShape.slabParentPartId : sourceShape.partId
        );
      }
    }
  },
  /**
   * update only for visible shapes
   */
  updateSlabPlaceholderFeatureId() {
    const shapes = workspace.getShapes();

    for (const shape of shapes) {
      if (
        shape instanceof sqftShape &&
        shape.partId === SHAPE_PART_ID.slabPlaceHolder
      ) {
        const overlappedIds = (shape.shapeIntersections?.getOverlappedWithShapeIds(INTERSECTION_MODE.SLAB) || [])
          .slice()
          .sort((a, b) => a - b);

        if (overlappedIds.length > 0) {
          // Find the first intersected shape that has a valid featureId
          let intersectedShape = null;
          for (const id of overlappedIds) {
            const shape = sqftShapeManager.getShapeById(id);
            if (shape && shape.featureId && !shape.isHidden) {
              intersectedShape = shape;
              break;
            }
          }

          // Assign featureId and slabParentPartId only if a valid intersected shape was found
          if (intersectedShape) {
            shape.setFeatureId(intersectedShape.featureId);
            shape.setSlabParentPartId(
              intersectedShape.slabParentPartId
                ? intersectedShape.slabParentPartId
                : intersectedShape.partId
            );
          }
        }
      }
    }
  },

  /**
   * This is not used anymore we have new logic were shapes dictate features for the slabs
   * @deprecated use updateSlabPlaceholderFeatureId
   */
  // updateShapesFeaturePlacedOnSlabImages() {
  //   const shapes = workspace.getShapes();
  //   for (const shape of shapes) {
  //     if (shape instanceof sqftShape) {
  //       //console.log("update feature shape.shapeIntersections.overlappedWithShapeIds", shape.shapeIntersections.overlappedWithShapeIds);
  //       if (shape.shapeIntersections.overlappedWithShapeIds.length >= 1) {
  //         const intersectedShape = sqftShapeManager.getShapeById(shape.shapeIntersections.overlappedWithShapeIds[0]);
  //         if (intersectedShape?.getFeature()?.getMatchingFeatureName() !== shape.getFeature()?.getMatchingFeatureName()) {
  //
  //           //set feature for additional shapes
  //           let slabAdditionalShape = SlabWorkspace.slabAdditionalShapes.findOneByBacksplashShapeId(shape.id);
  //           if (slabAdditionalShape) {
  //             const backsplashFeatureGroup = getBacksplashFeatureGroup();
  //             const intersectedShapeFeature = intersectedShape.getFeature();
  //             let neededFeature = null;
  //             if (intersectedShapeFeature) {
  //               neededFeature = CountertopSwitchers.getNeededFeatureFromNavItems(intersectedShapeFeature, backsplashFeatureGroup ?? shape.getFeature()?.getParent());
  //             }
  //             //console.log("backsplashFeatureGroup", backsplashFeatureGroup);
  //             //console.log("neededFeature", neededFeature);
  //             if (neededFeature) {
  //               slabAdditionalShape.line.setBacksplashFeatureId(neededFeature?.part?.dbFeature?.id);
  //             }
  //           }
  //
  //           if (intersectedShape.type === MOVABLE_IMAGE_TYPES.slabImage) {
  //             //set feature for shape pieces
  //             sqftSeamShapesManager.syncFeatureToSeamedShapes(shape, intersectedShape.featureId)
  //
  //             //set feature for the shape
  //             shape.setFeatureId(clone(intersectedShape.featureId));
  //             shape.setSlabParentPartId(clone(intersectedShape.slabParentPartId ? intersectedShape.slabParentPartId : intersectedShape.partId));
  //           }
  //         }
  //       }
  //     }
  //   }
  // },

  /**
   * set feature for each slabImage same as countertop shape placed on it
   */
  updateSlabImagesFeature() {
    const shapes = workspace.getShapes();
    for (const shape of shapes) {
      if (shape instanceof sqftShape || shape instanceof MovableImage) {
        //console.log("update feature shape.shapeIntersections.getOverlappedWithShapeIds(INTERSECTION_MODE.SLAB)", shape.shapeIntersections.getOverlappedWithShapeIds(INTERSECTION_MODE.SLAB));
        const overlappedWithIds = shape.shapeIntersections.getOverlappedWithShapeIds(INTERSECTION_MODE.SLAB);
        if (overlappedWithIds?.length >= 1) {
          const overlappedIds = (overlappedWithIds || [])
            .slice()
            .sort((a, b) => a - b);
          const intersectedShape = sqftShapeManager.getShapeById(overlappedIds[0]);
          if (intersectedShape?.getFeature()?.getMatchingFeatureName() !== shape.getFeature()?.getMatchingFeatureName()
            && !shape.isHidden) {

            if (intersectedShape && intersectedShape.type === MOVABLE_IMAGE_TYPES.slabImage) {
              //set feature for shape pieces
              //sqftSeamShapesManager.syncFeatureToSeamedShapes(intersectedShape, shape.featureId)

              //set feature for the shape
              intersectedShape.setFeatureId(clone(shape.featureId));
              //shape.setSlabParentPartId(clone(intersectedShape.slabParentPartId ? intersectedShape.slabParentPartId : intersectedShape.partId));
            }
          }
        }
      }
    }
  },

  /**
   * @deprecated use handleOpenSlabModeConflict
   * @param slabPlaceHolderShapes
   * @param callback
   */
  showSlabPlaceHolderErrorMessage (
    slabPlaceHolderShapes = sqftSlabManager.getSlabPlaceHolderShapes(),
    callback = new Function()
  ) {
    const state = store.getState();
    const isSlabModeConflictOpened = state.sqftModalFixState.isModalFixOpen && state.sqftModalFixState.id === 'slabModeConflict';
    if (isSlabModeConflictOpened) {
      return
    }
    for (const slabPlaceHolderShape of slabPlaceHolderShapes) {
      //console.log("slabPlaceHolderShape.getOverlappedWithShapeIds(INTERSECTION_MODE.SLAB)", slabPlaceHolderShape.shapeIntersections.getOverlappedWithShapeIds(INTERSECTION_MODE.SLAB));
      const overlappedWithIds = slabPlaceHolderShape.shapeIntersections.getOverlappedWithShapeIds(INTERSECTION_MODE.SLAB);
      if (overlappedWithIds.length >= 2) {
        const shapes = sqftShapeManager.getShapeByIds(overlappedWithIds);
        if (!sqftShapeManager.hasSameSharedFeatureName(shapes)
          && !sqftShapeManager.hasSameFeatureId(shapes)
        ) {

          renderErrorPopup(workspace.intl.formatMessage({id: "sqft.popup.system.slabPlaceholderMultipleOverlap"}));
          callback();
        }
      }
    }
  },

  /**
   * not used
   * @param slabShapes
   */
  // showSlabConflict (slabShapes) {
  //   for (const slabShape of slabShapes) {
  //     //console.log("slabShape.overlappedWithShapeIds", slabShape.shapeIntersections.overlappedWithShapeIds);
  //     if (slabShape.shapeIntersections.overlappedWithShapeIds.length >= 2) {
  //       const shapes = sqftShapeManager.getShapeByIds(slabShape.shapeIntersections.overlappedWithShapeIds);
  //       if (
  //         !sqftShapeManager.hasSameSharedFeatureName(shapes)
  //         && !sqftShapeManager.hasSameFeatureId(shapes)
  //       ) {
  //
  //         // renderErrorPopup(workspace.intl.formatMessage({id: "sqft.popup.system.slabPlaceholderMultipleOverlap"}));
  //         const slabConflicts = detectSlabConflicts();
  //         handleOpenSlabModeConflict(slabConflicts).then(r => void r);
  //       }
  //     }
  //   }
  // }
};

export default sqftShapeIntersectionsManager
